import createFetchTypes from '@app/utils/createFetchTypes';

const mainType = 'video';

export const uploadVideoTypes = createFetchTypes(`${mainType}_UPLOAD`);

export const filterVideoTypes = createFetchTypes(`${mainType}_FILTER_VIDEOS`);

export const filterVideoWithInfiniteTypes = createFetchTypes(
	`${mainType}_FILTER_VIDEOS_WITH_INFINITE`,
);

export const downloadVideoTypes = createFetchTypes(
	`${mainType}_DOWNLOAD_VIDEOS`,
);

export const toggleHideCaptionTypes = createFetchTypes(
	`${mainType}_TOGGLE_CAPTIONS`,
);

export const favoriteVideoTypes = createFetchTypes(
	`${mainType}_FAVORITE_VIDEO`,
);
export const archiveVideoTypes = createFetchTypes(`${mainType}_ARCHIVE_VIDEO`);

export const toggleShowWidgetTypes = `${mainType}_TOGGLE_SHOW_WIDGET`;

export const getSingleVideoTypes = createFetchTypes(
	`${mainType}_GET_SINGLE_VIDEO`,
);
export const getStreamingUrlTypes = createFetchTypes(
	`${mainType}_GET_STREAMING_URL`,
);

export const clearVideosType = 'video/CLEAR_VIDEOS';

export const updateThumbnailTypes = createFetchTypes(
	`${mainType}_UPDATE_THUMBNAIL`,
);
export const updateCaptionTypes = createFetchTypes(
	`${mainType}_UPDATE_CAPTIONS`,
);
export const getParsedCaptionTypes = createFetchTypes(
	`${mainType}_GET_PARSED_CAPTION`,
);
export const createCaptionSuggestionTypes = createFetchTypes(
	`${mainType}_CREATE_CAPTION_SUGGESTION`,
);
export const deleteCaptionSuggestionTypes = createFetchTypes(
	`${mainType}_DELETE_CAPTION_SUGGESTION`,
);
export const getCaptionSuggestionTypes = createFetchTypes(
	`${mainType}_GET_CAPTION_SUGGESTION`,
);

export const updateVideoTypes = createFetchTypes(`${mainType}_UPDATE_VIDEO`);

export const createFolderTypes = createFetchTypes(`${mainType}_CREATE_FOLDER`);
export const getVideoFoldersTypes = createFetchTypes(
	`${mainType}_GET_VIDEO_FOLDERS`,
);
export const addVideoToFolderTypes = createFetchTypes(
	`${mainType}_ADD_VIDEO_To_FOLDER`,
);
export const removeVideoFromFolderTypes = createFetchTypes(
	`${mainType}_REMOVE_VIDEO_FROM_FOLDER`,
);

export const editFolderTypes = createFetchTypes(`${mainType}_EDIT_FOLDER`);

export const deleteFolderTypes = createFetchTypes(`${mainType}_DELETE_FOLDER`);

export const getFolderTypes = createFetchTypes(`${mainType}_GET_FOLDER`);

export const deleteVideoTypes = createFetchTypes(`${mainType}_DELETE_VIDEO`);

export const clearFoldersType = 'video/CLEAR_FOLDERS';

export type CueData = {
	confidence: number;
	categories?: string[];
};

export type CueType = {
	start: number;
	end: number;
	identifier: string;
	styles: string;
	text: string;
	confidence?: number;
};

export type SubtitleType = {
	cues: CueType[];
	errors: any;
	strict: boolean;
	valid: boolean;
};

export type CaptionsType = {
	_id: string;
	language: string;
	url: string;
};
